// frontend/src/askos/mentoring/StudentMentoringCallPage.js
import React from 'react';
import MentoringCallPage from '../../components/Common/MentoringCallPage';

const StudentMentoringCallPage = () => (
    <MentoringCallPage role="student" backTo="/samkalp-ias/mentoring/my-bookings" />
);

export default StudentMentoringCallPage;
